module.exports = __webpack_public_path__ + "static/media/photo-of-house-covered-with-snow-1493202.b6a2df8e.jpg";